import {
  BETA_INDSTOCKS_HOST,
  INDGLOBAL_HOST,
  INDSTOCKS_HOST,
} from '@/root/constants/common'

export const loggedOutNavLinks = [
  {
    text: 'Features',
    link: '/features',
    dontShowOn: [
      { host: INDSTOCKS_HOST, pathnameExact: '/' },
      { host: INDGLOBAL_HOST, pathnameExact: '/' },
      { host: BETA_INDSTOCKS_HOST, pathnameExact: '/' },
    ],
  },
  {
    text: 'Pricing',
    link: '/pricing?type=indian-stocks',
    navlinks: [
      { host: INDSTOCKS_HOST, pathnameExact: '/pricing?type=indian-stocks' },
      { host: INDGLOBAL_HOST, pathnameExact: '/pricing?type=us-stocks' },
    ],
  },
  {
    text: 'Blog',
    link: '/blog',
    dontShowOn: [
      { host: INDSTOCKS_HOST, pathnameExact: '/' },
      { host: INDGLOBAL_HOST, pathnameExact: '/' },
      { host: BETA_INDSTOCKS_HOST, pathnameExact: '/' },
    ],
  },
  {
    text: 'Customer Service',
    link: '/customer-service',
    showOnlyOn: [
      {
        host: INDSTOCKS_HOST,
        pathnameExact: '/',
      },
      {
        host: INDGLOBAL_HOST,
        pathnameExact: '/',
      },
      { host: BETA_INDSTOCKS_HOST, pathnameExact: '/' },
    ],
    navlinks: [
      {
        host: INDSTOCKS_HOST,
        pathnameExact: '/customer-service?topic_id=9&searchFilter=FAQ',
      },
      {
        host: INDGLOBAL_HOST,
        pathnameExact: '/customer-service?topic_id=11&searchFilter=FAQ',
      },
    ],
  },
]

export const loggedInNavLinks = [
  {
    text: 'Dashboard',
    link: '/dashboard',
    nativeAnchor: false,
    type: '/dashboard',
  },
  {
    text: 'INDstocks',
    link: `https://${INDSTOCKS_HOST}/app/stocks/my-stocks/nifty-50`,
    nativeAnchor: false,
    type: '/stocks',
  },
  {
    text: 'Mutual Funds',
    link: '/investments/mutual-fund/explore-all',
    nativeAnchor: false,
    type: '/mutual-fund',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },

  {
    text: 'Fixed Deposits',
    link: '/investments/fixed-deposit/explore-all',
    nativeAnchor: false,
    type: '/fixed-deposit',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },
  {
    text: 'US Stocks',
    link: '/investments/us-stocks/explore-all',
    nativeAnchor: false,
    type: '/us-stocks',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },
]

export const loggedInNavLinksWithFnO = [
  {
    text: 'Dashboard',
    link: '/dashboard',
    nativeAnchor: false,
    type: '/dashboard',
  },
  {
    text: 'INDstocks',
    link: `https://${INDSTOCKS_HOST}/app/stocks/my-stocks/nifty-50`,
    nativeAnchor: true,
    type: '/stocks',
  },
  {
    text: 'F&O',
    link: `https://${INDSTOCKS_HOST}/futures-and-options`,
    nativeAnchor: false,
    type: '/futures-and-options',
  },
  {
    text: 'Mutual Funds',
    link: '/investments/mutual-fund/explore-all',
    nativeAnchor: false,
    type: '/mutual-fund',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },

  {
    text: 'Fixed Deposits',
    link: '/investments/fixed-deposit/explore-all',
    nativeAnchor: false,
    type: '/fixed-deposit',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },
  {
    text: 'US Stocks',
    link: '/investments/us-stocks/explore-all',
    nativeAnchor: false,
    type: '/us-stocks',
    dontShowOn: [{ host: INDSTOCKS_HOST, pathnameExact: '/' }],
  },
]
